export default __webpack_public_path__ + "static/media/ISSO SYLLABUS 2027-26 CLASS 2.418ef1e5.pdf";